/* Crisp vector brand mark for small chrome placements (nav/footer/sidebar) --
   the photographic cube logo (frontend/public/brand/blueprints-logo-nobg.png)
   reads as an unrecognizable blob at 20-28px, so small instances use this
   abstract hexagon + compass-line glyph instead (same geometric family as
   the hexagonal "B" mark and the .lodge-mark square-and-compass motif in
   index.css). The cube photo is reserved for anywhere it's shown large
   enough for the detail to actually read. */
const BlueprintMark = ({ className }) => (
  <svg className={className} viewBox="0 0 32 32" fill="none">
    <path d="M16 2 L28 9 V23 L16 30 L4 23 V9 Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M16 2 V30 M4 9 L28 23 M28 9 L4 23" stroke="currentColor" strokeWidth="1" opacity="0.55" />
    <circle cx="16" cy="16" r="1.6" fill="currentColor" />
  </svg>
);

export default BlueprintMark;
